import React, { useEffect, useState } from 'react'
// import Geocode from 'react-geocode'
import Proj4 from 'proj4'
import GooglePlacesAutocomplete, {
  geocodeByPlaceId
} from 'react-google-places-autocomplete'

// EPSG:2056 (CH1903+ / LV95)
// https://epsg.io/2056 Export -> proj.4
const dst = new Proj4.Proj(
  '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'
)
const src = new Proj4.Proj('WGS84')

// Geocode.setApiKey('AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA')
// Geocode.setLanguage('fr')
// Geocode.setRegion('ch')
// Geocode.setLocationType('ROOFTOP')
// Geocode.enableDebug()

interface Props {
  handleResult: () => void
}

export const GetPos = ({ handleResult }: Props) => {
  // const [latlng, setLatlng] = useState(null)
  // const [chCoords, setChCoords] = useState(null)
  const [address, setAddress] = useState(null)

  useEffect(() => {
    address &&
      geocodeByPlaceId(address.value.place_id)
        .then(results => {
          const lat = results[0].geometry.location.lat()
          const lng = results[0].geometry.location.lng()

          // const point = new Proj4.Point(lng, lat)
          // const chPoint = Proj4.transform(src, dst, point)

          // setLatlng([lat, lng])
          // setChCoords([chPoint.x, chPoint.y])
          handleResult([lng, lat])
        })
        .catch(error => console.error(error))
  }, [address])

  return (
    <div>
      <GooglePlacesAutocomplete
        apiOptions={{
          language: 'fr',
          region: 'CH'
        }}
        autocompletionRequest={{
          bounds: [
            { lat: 47, lng: 5.88 },
            { lat: 46.12, lng: 7.3 }
          ],
          componentRestrictions: {
            country: ['ch']
          }
        }}
        selectProps={{
          address,
          onChange: setAddress,
          placeholder: 'Entrer une adresse ou un lieu',
          noOptionsMessage: () => 'Aucun résultat',
          loadingMessage: () => 'Chargement...',
          styles: {
            placeholder: provided => ({
              ...provided,
              fontFamily: 'TamediaChart',
              color: '#e3e3e3'
            }),
            input: provided => ({
              ...provided,
              fontFamily: 'TamediaChart'
            }),
            menuList: provided => ({
              ...provided,
              fontFamily: 'TamediaChart'
            }),
            valueContainer: provided => ({
              ...provided,
              fontFamily: 'TamediaChart'
            })
          }
        }}
        apiKey='AIzaSyDykwbOym-uh9R3CQUG1H1By9FH12LCI3Y'
      />
      {/* <div className='ui text container'>
        <div className='ta-small'>
          Si l'adresse n'est pas suffisamment précise, c'est la région ou la
          commune qui est utilisée.
        </div>
      </div> */}
      {/* <div>{latlng && latlng.toString()}</div>
      <div>{chCoords && chCoords.toString()}</div> */}
    </div>
  )
}
